import { createContext, useContext, useEffect, useState, type RefObject } from 'react';

export type ModoTela = 'pc' | 'tablet' | 'cel' | 'deitado';

/** Igual a `modoDe` do protótipo. w e h são o tamanho do <main class="world">. */
export const modoDe = (w: number, h: number): ModoTela =>
  w < 700 ? 'cel' : h < 520 ? 'deitado' : w < 1100 ? 'tablet' : 'pc';

export const ModoTelaContext = createContext<ModoTela>('pc');
export const useModo = () => useContext(ModoTelaContext);
export const useCompacto = () => {
  const m = useModo();
  return m === 'cel' || m === 'deitado';
};

export function useModoTela(ref: RefObject<HTMLElement | null>): ModoTela {
  const [modo, setModo] = useState<ModoTela>('pc');
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const ler = () => {
      const next = modoDe(el.clientWidth, el.clientHeight);
      setModo(atual => (atual === next ? atual : next));
    };
    ler();
    const ro = new ResizeObserver(ler);
    ro.observe(el);
    return () => ro.disconnect();
  }, [ref]);
  return modo;
}
